import ModalArreteRegisseur from './ModalArreteRegisseur';

type ModalArreteComptableProps = {
  onDismiss: () => void;
  hasReglements?: boolean;
};

const ModalArreteComptable = (props: ModalArreteComptableProps) => {
  const { onDismiss, hasReglements = false } = props;

  return <ModalArreteRegisseur onClose={onDismiss} hasReglements={hasReglements} />;
};

export default ModalArreteComptable;
